function toTitleCaseWords(name: string): string[] {
  return name
    .trim()
    .toLocaleLowerCase('es')
    .split(/\s+/)
    .filter(Boolean)
    .map(word => word.charAt(0).toLocaleUpperCase('es') + word.slice(1));
}

export function formatPayerShortName(name: string): string {
  const words = toTitleCaseWords(name);

  if (words.length < 2) {
    return words.join(' ');
  }
  return `${words[0]} ${words[words.length - 1].charAt(0)}.`;
}
